import { defineComponent, h, getCurrentInstance } from 'vue'
import { Editor } from '@tiptap/core'

export default defineComponent({
  name: 'NodeViewContent',

  props: {
    editor: {
      type: Editor
    },
    as: {
      type: String
    }
  },
  setup (props) {
    const instance = getCurrentInstance()
    const theEditor = props.editor || (instance?.parent)?.ctx?.editor
    const theAs = props.as || (instance?.parent)?.ctx?.contentAs || 'div'
    return {
      theEditor,
      theAs
    }
  },
  render () {
    return h(
      this.theAs, {
        style: {
          whiteSpace: 'pre-wrap'
        },
        'data-NodeViewContent': true,
        contenteditable: this.theEditor?.isEditable // TODO: check this as its not the reactive version
      }
    )
  }
})
